import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "modal" };
const _hoisted_2 = { class: "modal-header" };
const _hoisted_3 = { class: "modal-title" };
const _hoisted_4 = { class: "avatar-top" };
const _hoisted_5 = ["src"];
const _hoisted_6 = {
    key: 1,
    class: "avatar-placeholder"
};
const _hoisted_7 = { class: "profile-row" };
const _hoisted_8 = { class: "fields" };
const _hoisted_9 = { class: "row" };
const _hoisted_10 = {
    class: "input-group",
    style: { "flex": "1 1 auto" }
};
const _hoisted_11 = { class: "field" };
const _hoisted_12 = {
    class: "input-group",
    style: { "flex": "1 1 auto" }
};
const _hoisted_13 = { class: "field" };
const _hoisted_14 = { class: "row" };
const _hoisted_15 = {
    class: "input-group",
    style: { "flex": "1 1 320px" }
};
const _hoisted_16 = { class: "field" };
const _hoisted_17 = {
    class: "input-group",
    style: { "flex": "1 1 400px" }
};
const _hoisted_18 = { class: "field password-field" };
const _hoisted_19 = { class: "pill-group" };
const _hoisted_20 = { class: "row roles" };
const _hoisted_21 = ["aria-checked"];
const _hoisted_22 = ["aria-checked"];
const _hoisted_23 = ["aria-checked"];
const _hoisted_24 = { class: "notify" };
const _hoisted_25 = { class: "row" };
const _hoisted_26 = {
    class: "input-group",
    style: { "flex": "1 1 auto" }
};
const _hoisted_27 = { class: "field" };
const _hoisted_28 = {
    key: 0,
    class: "financial-toggle"
};
const _hoisted_29 = {
    key: 0,
    class: "pill-group",
    style: { "margin-top": "6px" }
};
const _hoisted_30 = { class: "row categories-row" };
const _hoisted_31 = ["onClick"];
const _hoisted_32 = ["aria-checked"];
const _hoisted_33 = { class: "pill-label" };
const _hoisted_34 = { class: "modal-footer" };
const _hoisted_35 = {
    key: 0,
    class: "form-error",
    role: "alert"
};
const _hoisted_36 = ["disabled"];
const _hoisted_37 = { key: 0 };
const _hoisted_38 = { key: 1 };
const _hoisted_39 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: "modal-backdrop",
        onClick: _cache[16] || (_cache[16] = _withModifiers(
        //@ts-ignore
        (...args) => (_ctx.onClose && _ctx.onClose(...args)), ["self"]))
    }, [
        _createElementVNode("div", _hoisted_1, [
            _cache[30] || (_cache[30] = _createElementVNode("div", {
                class: "hero-circle",
                "aria-hidden": "true"
            }, null, -1)),
            _createElementVNode("header", _hoisted_2, [
                _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                        class: "avatar-bubble",
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args))),
                        role: "button",
                        tabindex: "0",
                        onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)), ["prevent"]), ["enter"])),
                        "aria-label": "Add profile picture"
                    }, [
                        (_ctx.photoPreview)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.photoPreview,
                                alt: "Profile picture preview",
                                class: "avatar-img"
                            }, null, 8, _hoisted_5))
                            : (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[17] || (_cache[17] = [
                                _createTextVNode("Add", -1),
                                _createElementVNode("br", null, null, -1),
                                _createTextVNode("Profile", -1),
                                _createElementVNode("br", null, null, -1),
                                _createTextVNode("Picture", -1)
                            ])))
                    ], 32),
                    _createElementVNode("input", {
                        ref: "fileInput",
                        class: "avatar-input",
                        type: "file",
                        accept: "image/*",
                        onChange: _cache[2] || (_cache[2] =
                            //@ts-ignore
                            (...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
                    }, null, 544)
                ])
            ]),
            _createElementVNode("form", {
                class: "modal-body",
                onSubmit: _cache[15] || (_cache[15] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
                novalidate: ""
            }, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "pill-group__label" }, "Name", -1)),
                                _createElementVNode("label", _hoisted_11, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.firstName) = $event)),
                                        required: ""
                                    }, null, 512), [
                                        [_vModelText, _ctx.firstName]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "pill-group__label" }, "Surname", -1)),
                                _createElementVNode("label", _hoisted_13, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.lastName) = $event))
                                    }, null, 512), [
                                        [_vModelText, _ctx.lastName]
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "pill-group__label" }, "Email", -1)),
                                _createElementVNode("label", _hoisted_16, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.email) = $event)),
                                        type: "email",
                                        required: ""
                                    }, null, 512), [
                                        [_vModelText, _ctx.email]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "pill-group__label" }, "Password", -1)),
                                _createElementVNode("div", _hoisted_18, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.password) = $event)),
                                        type: "text"
                                    }, null, 512), [
                                        [_vModelText, _ctx.password]
                                    ]),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "gen-btn",
                                        onClick: _cache[7] || (_cache[7] = _withModifiers(
                                        //@ts-ignore
                                        (...args) => (_ctx.generatePassword && _ctx.generatePassword(...args)), ["prevent"]))
                                    }, "Generate Password")
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "pill-group__label" }, "User Role", -1)),
                            _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["role-pill", { active: _ctx.role === 'admin' }]),
                                    onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.selectRole('admin')))
                                }, [
                                    _createElementVNode("span", {
                                        class: "checkbox",
                                        "aria-checked": _ctx.role === 'admin'
                                    }, null, 8, _hoisted_21),
                                    _cache[22] || (_cache[22] = _createElementVNode("span", { class: "pill-label" }, "Administrator", -1))
                                ], 2),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["role-pill", { active: _ctx.role === 'staff' }]),
                                    onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.selectRole('staff')))
                                }, [
                                    _createElementVNode("span", {
                                        class: "checkbox",
                                        "aria-checked": _ctx.role === 'staff'
                                    }, null, 8, _hoisted_22),
                                    _cache[23] || (_cache[23] = _createElementVNode("span", { class: "pill-label" }, "Staff", -1))
                                ], 2),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["role-pill", { active: _ctx.role === 'client' }]),
                                    onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.selectRole('client')))
                                }, [
                                    _createElementVNode("span", {
                                        class: "checkbox",
                                        "aria-checked": _ctx.role === 'client'
                                    }, null, 8, _hoisted_23),
                                    _cache[24] || (_cache[24] = _createElementVNode("span", { class: "pill-label" }, "Client", -1))
                                ], 2)
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_24, [
                            _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.sendNotification) = $event))
                            }, null, 512), [
                                [_vModelCheckbox, _ctx.sendNotification]
                            ]),
                            _cache[26] || (_cache[26] = _createTextVNode(" Send notification of account creation to the user along with login details and a temporary password ", -1))
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "pill-group__label" }, "Company Name", -1)),
                                _createElementVNode("label", _hoisted_27, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.companyName) = $event))
                                    }, null, 512), [
                                        [_vModelText, _ctx.companyName]
                                    ])
                                ])
                            ]),
                            (_ctx.role === 'staff' || _ctx.role === 'client')
                                ? (_openBlock(), _createElementBlock("label", _hoisted_28, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.financialVisibility) = $event))
                                    }, null, 512), [
                                        [_vModelCheckbox, _ctx.financialVisibility]
                                    ]),
                                    _cache[28] || (_cache[28] = _createElementVNode("span", { class: "financial-label" }, "Financial Visibility", -1))
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        (_ctx.role === 'client')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "pill-group__label" }, "Categories", -1)),
                                _createElementVNode("div", _hoisted_30, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
                                        return (_openBlock(), _createElementBlock("label", {
                                            key: cat,
                                            class: _normalizeClass(["role-pill category-pill", { active: _ctx.selectedCategories.includes(cat) }]),
                                            onClick: _withModifiers(($event) => (_ctx.toggleCategory(cat)), ["prevent"])
                                        }, [
                                            _createElementVNode("span", {
                                                class: "checkbox",
                                                "aria-checked": _ctx.selectedCategories.includes(cat)
                                            }, null, 8, _hoisted_32),
                                            _createElementVNode("span", _hoisted_33, _toDisplayString(cat), 1)
                                        ], 10, _hoisted_31));
                                    }), 128))
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createElementVNode("footer", _hoisted_34, [
                    (_ctx.errorMessage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.errorMessage), 1))
                        : _createCommentVNode("", true),
                    _createElementVNode("button", {
                        disabled: _ctx.loading,
                        type: "submit",
                        class: "create-btn"
                    }, [
                        (_ctx.loading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Creating…"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_38, "Create User"))
                    ], 8, _hoisted_36),
                    _createElementVNode("button", {
                        type: "button",
                        class: "secondary-btn",
                        onClick: _cache[14] || (_cache[14] =
                            //@ts-ignore
                            (...args) => (_ctx.onClose && _ctx.onClose(...args))),
                        disabled: _ctx.loading
                    }, "Cancel", 8, _hoisted_39)
                ])
            ], 32)
        ])
    ]));
}
